import { render, staticRenderFns } from "./MainContentHotkeys.vue?vue&type=template&id=be7f1f54&lang=pug"
import script from "./MainContentHotkeys.vue?vue&type=script&lang=js"
export * from "./MainContentHotkeys.vue?vue&type=script&lang=js"
import style0 from "./MainContentHotkeys.vue?vue&type=style&index=0&id=be7f1f54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports